import { useEffect, useRef, useState, useSyncExternalStore } from "react";
import { sidePanelWidth } from "../components/PinnedPanel";

const MIN_CONTENT_WIDTH = 480;

const listeners = new Set<() => void>();

function subscribe(callback: () => void) {
  listeners.add(callback);
  window.addEventListener("storage", callback);
  return () => {
    listeners.delete(callback);
    window.removeEventListener("storage", callback);
  };
}

export function usePinnedPanel(storageKey: string) {
  const pinned = useSyncExternalStore(
    subscribe,
    () => localStorage.getItem(storageKey) === "true"
  );
  const togglePinned = () => {
    localStorage.setItem(storageKey, String(!pinned));
    for (const listener of listeners) listener();
  };

  const layoutRef = useRef<HTMLDivElement>(null);
  // A boolean, not the width, so resizing only re-renders when it flips.
  const [hasRoom, setHasRoom] = useState<boolean | null>(null);
  useEffect(() => {
    const layout = layoutRef.current;
    if (!layout) return;
    const observer = new ResizeObserver(([entry]) => {
      if (entry)
        setHasRoom(
          entry.contentRect.width >= sidePanelWidth + MIN_CONTENT_WIDTH
        );
    });
    observer.observe(layout);
    return () => observer.disconnect();
  }, []);

  return {
    layoutRef,
    measured: hasRoom !== null,
    pinned,
    togglePinned,
    hasRoom: hasRoom === true,
    open: pinned && hasRoom === true,
  };
}
